import React, { useState } from "react";
import { promoteToAdmin } from "../../lib/api/users";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { UserRole } from "../../API";

const PromoteUser: React.FC = () => {
  const [email, setEmail] = useState("medina.christopher@gmail.com"); // Christopher Medina's email
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handlePromote = async () => {
    setIsLoading(true);
    setMessage("");

    try {
      const result = await promoteToAdmin(email);

      if (result) {
        setMessage(
          `✅ Successfully promoted ${email} to ${UserRole.ADMIN} role!`
        );
      } else {
        setMessage(
          "❌ Failed to promote user. User might not exist or there was an error."
        );
      }
    } catch (error) {
      setMessage(
        `❌ Error: ${error instanceof Error ? error.message : "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle>Promote User to Admin</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">
              Email Address
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter user email"
            />
          </div>

          <Button
            onClick={handlePromote}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? "Promoting..." : "Promote to Admin"}
          </Button>

          {message && (
            <div
              className={`p-3 rounded-md text-sm ${
                message.includes("✅")
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {message}
            </div>
          )}

          <div className="text-sm text-gray-600 mt-4">
            <p>
              <strong>Note:</strong> This will promote the user to ADMIN role in
              DynamoDB.
            </p>
            <p>
              Christopher Medina's email is pre-filled:{" "}
              <code>medina.christopher@gmail.com</code>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PromoteUser;
